import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';
import { Button } from './ui/button';

const StickyCallButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling down 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-in fade-in slide-in-from-bottom-5 duration-300">
      <a href="tel:0434600945">
        <Button className="bg-green-600 hover:bg-green-700 text-white px-6 py-4 rounded-full font-semibold flex items-center gap-3 shadow-2xl hover:shadow-3xl transition-all transform hover:scale-110">
          <Phone className="h-5 w-5" />
          <span className="hidden sm:inline">Call Now</span>
        </Button>
      </a>
    </div>
  );
};

export default StickyCallButton;
